module.exports = __webpack_public_path__ + "img/G@2x.b23b606.jpg";